import { dialog } from '@forest/shared/solid'
import { onCleanup, onMount } from 'solid-js'
import { closeShop } from '~/lib/close-shop'
import { m } from '~/paraglide/messages'

export function BootstrapErrorDialog(props: { code: string }) {
  onMount(() => {
    void dialog.open({
      action: closeShop,
      button: m.btn_got_it(),
      closeOnEscapeKeyDown: false,
      description: m
        .dialog_something_went_wrong_description()
        .replace('[%s]', props.code),
      role: 'alertdialog',
      testId: 'bootstrap-error',
      title: m.dialog_something_went_wrong_title(),
    })
  })
  onCleanup(() => dialog.close())

  return null
}
